<div @statisticsState
  class="statistics-html-container" [innerHTML]="safeHtml">

</div>
